import React, { useEffect, useRef, useState } from 'react';
import { Button, Input } from 'antd';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { copyText } from '../azureOnboarding.utils';

interface CopyFieldProps {
  label: string;
  value: string;
  primary?: boolean;
}

const CopyField: React.FC<CopyFieldProps> = ({ label, value, primary }) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    []
  );

  const handleCopy = async () => {
    await copyText(value);
    setCopied(true);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), 2500);
  };

  return (
    <Input.Group compact style={{ display: 'flex' }}>
      <Input value={value} readOnly aria-label={label} size={primary ? 'middle' : 'small'} />
      <Button
        icon={copied ? <CheckOutlined /> : <CopyOutlined />}
        type={primary && !copied ? 'primary' : 'default'}
        size={primary ? 'middle' : 'small'}
        onClick={handleCopy}
        aria-label={`Copy ${label}`}
      >
        {copied ? 'Copied!' : 'Copy'}
      </Button>
    </Input.Group>
  );
};

export default CopyField;
